// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktopWrap":"bge_a","AdSlotBranding__desktop":"bge_b","AdSlotBranding__mobile":"bge_c"};